module.exports = __webpack_public_path__ + "img/gRNAResult.0ff1566d.png";